import axios from 'axios'

export const diplomatAxios = axios.create({
    baseURL: process.env.REACT_APP_DIPLOMAT_URL,
    headers: {
        Authorization: `Bearer ${process.env.REACT_APP_DIPLOMAT_TOKEN}`,
    },
})